<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="rewardorders-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Zamówienia nagród</h1>
      </div>
    </div>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="orders"
          class="elevation-1"
          :loading="loading"
        >
          <template v-slot:top>
            <div class="table-section-title">
              <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-gift</v-icon></div>
              <div class="filter-title">{{ $t('pointsRewardOrders.title') }}</div>
            </div>
          </template>
          <template v-slot:item.reward="{ item }">
            <div>
              <strong>{{ item.rewardName }}</strong>
              <br />
              <span class="grey--text text--darken-1">{{ item.rewardValue }}</span>
            </div>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              :color="statusColor(item.status)"
              dark
              small
            >
              {{ statusLabel(item.status) }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <template v-if="item.status === 'PENDING'">
              <v-btn small color="success" class="mr-2" @click="approveOrder(item)">
                <v-icon small left>mdi-check</v-icon>{{ $t('common.approve') }}
              </v-btn>
              <v-btn small color="error" @click="rejectOrder(item)">
                <v-icon small left>mdi-close</v-icon>{{ $t('common.reject') }}
              </v-btn>
            </template>
            <template v-else-if="item.status === 'APPROVED'">
              <v-btn small color="blue" dark @click="markIssued(item)">
                <v-icon small left>mdi-package-variant-closed-check</v-icon>{{ $t('pointsRewardOrders.issued') }}
              </v-btn>
            </template>
            <span v-else class="grey--text">-</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const axios = require("axios");
import * as dayjs from "dayjs";
export default {
  data() {
    return {
      loading: false,
      orders: [],
      headers: [
        { text: "Kierowca", value: "driverName", sortable: false },
        { text: "Nagroda", value: "reward", sortable: false },
        { text: "Koszt pkt", value: "costPoints", sortable: false },
        { text: "Status", value: "status", sortable: false },
        { text: "Data", value: "date", sortable: false },
        { text: "Akcje", value: "actions", sortable: false },
      ],
    };
  },
  async created() {
    await this.initialize();
  },
  methods: {
    getAuthHeaders() {
      return {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
    },
    async toggleLoading(type) {
      localStorage.setItem("loading", type);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    statusColor(status) {
      const map = {
        PENDING: "orange",
        APPROVED: "green",
        ISSUED: "blue",
        REJECTED: "red",
      };
      return map[status] || "grey";
    },
    statusLabel(status) {
      const map = {
        PENDING: "Oczekujace",
        APPROVED: "Zatwierdzone",
        ISSUED: "Odebrana",
        REJECTED: "Odrzucone",
      };
      return map[status] || status;
    },
    async initialize() {
      this.loading = true;
      try {
        const res = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "points/admin/rewards/orders",
          headers: this.getAuthHeaders(),
        });
        const data = res.data.data || res.data;
        const result = Array.isArray(data) ? data : data.result || data.items || [];
        this.orders = result.map((item) => {
          return {
            id: item.id,
            driverName:
              item.driverName ||
              (item.driver
                ? item.driver.firstName + " " + item.driver.lastName
                : "-"),
            rewardName: item.rewardName || (item.reward ? item.reward.name : "-"),
            rewardValue:
              item.rewardValue != null
                ? item.rewardValue + " PLN"
                : item.reward && item.reward.valueZl != null
                ? item.reward.valueZl + " PLN"
                : "",
            costPoints: item.costPoints || (item.reward ? item.reward.costPoints : "-"),
            status: item.status || "PENDING",
            date: item.createdAt
              ? dayjs(item.createdAt).format("DD-MM-YYYY")
              : "-",
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire(
          "Blad",
          e.response?.data?.message?.toString() || "Wystapil blad",
          "error"
        );
      }
      this.loading = false;
    },
    async approveOrder(item) {
      Swal.fire({
        title: "Zatwierdzic zamowienie?",
        text: "Nagroda zostanie przyznana kierowcy.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.toggleLoading(true);
          try {
            await axios({
              method: "post",
              url:
                process.env.VUE_APP_ROOT_API +
                "points/admin/rewards/orders/approve",
              headers: this.getAuthHeaders(),
              data: { orderId: item.id },
            });
            Swal.fire("Zatwierdzono", "Zamowienie zostalo zatwierdzone", "success");
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire(
              "Blad",
              e.response?.data?.message?.toString() || "Wystapil blad",
              "error"
            );
          }
          await this.toggleLoading(false);
        }
      });
    },
    async markIssued(item) {
      const result = await Swal.fire({
        title: "Oznacz jako odebrana?",
        text: "Nagroda zostanie oznaczona jako wydana kierowcy.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Tak, odebrana",
        cancelButtonText: "Anuluj",
      });
      if (!result.isConfirmed) return;
      await this.toggleLoading(true);
      try {
        await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "points/admin/rewards/orders/issued",
          headers: this.getAuthHeaders(),
          data: { orderId: item.id },
        });
        Swal.fire("Oznaczono", "Nagroda oznaczona jako odebrana", "success");
        await this.initialize();
      } catch (e) {
        console.log(e);
        Swal.fire("Blad", e.response?.data?.message?.toString() || "Wystapil blad", "error");
      }
      await this.toggleLoading(false);
    },
    async rejectOrder(item) {
      Swal.fire({
        title: "Odrzucic zamowienie?",
        text: "Punkty zostana zwrocone kierowcy.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Odrzuc",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.toggleLoading(true);
          try {
            await axios({
              method: "post",
              url:
                process.env.VUE_APP_ROOT_API +
                "points/admin/rewards/orders/reject",
              headers: this.getAuthHeaders(),
              data: { orderId: item.id },
            });
            Swal.fire("Odrzucono", "Zamowienie zostalo odrzucone", "success");
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire(
              "Blad",
              e.response?.data?.message?.toString() || "Wystapil blad",
              "error"
            );
          }
          await this.toggleLoading(false);
        }
      });
    },
  },
};
</script>

<style scoped>
.rewardorders-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { padding: 4px 4px 18px; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; text-transform: capitalize; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }
.table-section-title { display: flex; align-items: center; gap: 10px; padding: 14px 16px 12px; border-bottom: 1px solid rgba(255,255,255,0.06); }
.filter-icon { width: 32px; height: 32px; border-radius: 10px; background: rgba(41,98,255,0.18); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.filter-title { font-size: 15px; font-weight: 700; color: #fff; letter-spacing: -0.01em; flex-grow: 1; }

.rewardorders-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.rewardorders-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.rewardorders-page >>> .v-data-table tbody tr { background: #232838 !important; }
.rewardorders-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.rewardorders-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.rewardorders-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.rewardorders-page >>> .grey--text { color: #B0BEC5 !important; }
.rewardorders-page >>> .v-btn:not(.v-btn--icon) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.rewardorders-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.rewardorders-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.rewardorders-page >>> .v-dialog .v-card { background: #232838 !important; }
</style>
